import { ChartPie } from 'lucide-react';
import * as React from 'react';
import { Translate } from 'react-localize-redux';
import Dashboards, {
	MobileDashboard
} from '../../containers_v2/dashboard/Dashboard';
import { PrimaryColor } from '../../styles/global/css/Utils';
import { Route } from '../Routes';

const DashboardRoutes = (): Route[] => [
	{
		component: Dashboards,
		path: '/dashboard',
		name: <Translate id="general.dashboard" />,
		logoImg: <ChartPie size='16' />,
		hoverImg: <ChartPie color={PrimaryColor} size='16' />,
		activeImg: <ChartPie color={PrimaryColor} size='16' />,
		permission: ['ViewDashboard'],
		menu: true,
		submenu: false
	},
	{
		component: MobileDashboard,
		path: '/mobile-dashboard',
		permission: ['ViewDashboard'],
		admin: true
	}
];
export default DashboardRoutes;
